import { render, staticRenderFns } from "./distributor_editor.vue?vue&type=template&id=3db9d6d0"
import script from "./distributor_editor.vue?vue&type=script&lang=js"
export * from "./distributor_editor.vue?vue&type=script&lang=js"
import style0 from "./distributor_editor.vue?vue&type=style&index=0&id=3db9d6d0&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports